export function initializeLanguageProperties(ngLocale: string, dir: string) {
  globalThis.__locale = ngLocale;
  globalThis.__rtl = dir === "rtl";

  // Override navigator.language to use the Angular build locale instead
  // of the browser/OS default.
  try {
    Object.defineProperty(navigator, "language", {
      get: () => ngLocale,
      configurable: true,
    });
    Object.defineProperty(navigator, "languages", {
      get: () => Object.freeze([ngLocale]),
      configurable: true,
    });
  } catch {
    // Some environments (e.g. certain test runners) may not allow this
    // nothing we can do but also this is not critical
  }

  // Patch String.prototype.localeCompare so calls without an explicit locale
  // (e.g. a.localeCompare(b)) use the Angular build locale.
  const originalLocaleCompare = String.prototype.localeCompare;
  String.prototype.localeCompare = function (
    that: string,
    locales?: string | string[],
    options?: Intl.CollatorOptions,
  ) {
    return originalLocaleCompare.call(this, that, locales ?? ngLocale, options);
  };
}
